import { Modal, } from 'reactstrap';
import { FaTimes } from 'react-icons/fa';
import { useState } from 'react';
import { baseUrl } from '../../../shared/baseUrl';
import { createNotification } from '../../Common/CreateNotification';
import { checkAuth } from '../../../Utils/CheckAuthentication';
import { useDispatch } from 'react-redux';
import { toggleLoading } from '../../../Redux/reducers/loadingSlice';

const ForgotPassword = ({ isOpen, onClose }) => {
    const [email, setEmail] = useState('');
    const [codeSent, setCodeSent] = useState(false);
    const dispatch = useDispatch();


    const sendResetLink = (e) => {
        e.preventDefault();
        dispatch(toggleLoading(true));
        var formData = new FormData();
        formData.append('email', email);
        fetch(baseUrl + 'password-reset', {
            method: 'POST',
            body: formData
        })
            .then(res => checkAuth(res))
            .then(res => {
                if (res.success) {
                    createNotification('success', res.message);
                    dispatch(toggleLoading(false));
                    setCodeSent(true);

                }
                else {
                    createNotification('error', res.message);
                    dispatch(toggleLoading(false));
                }
            })
            .catch(err => {
                createNotification('error', "Error sending password reset link.");
                dispatch(toggleLoading(false));
            });
    }



    return (
        <>
            <Modal isOpen={isOpen} className='position-relative' centered>
                <div onClick={onClose} className='position-absolute cursor-pointer' style={{ top: 6, right: 10 }}>
                    <FaTimes size={20} />
                </div>
                <div className='px-3 py-3'>
                    {!codeSent ?
                        <form onSubmit={sendResetLink}>
                            <h3>Reset Password:</h3>
                            <p className='small'>Plese enter your email address. The password reset link will be sent to your mail address.</p>
                            <input type="email" required placeholder='Email Adress' className='form-control' value={email} onChange={(e) => { setEmail(e.target.value) }} />
                            <div className="col-12 d-flex justify-content-start my-3">
                                <button type="submit" className="btn btn-primary">Send</button>
                            </div>
                        </form> :
                        <>
                            <div className='my-4'>
                                <p className='fs-3'>Password reset link has been sent to your mail address. Please check your mail.</p>
                                <p className='small'>If you didn't receive the mail, make sure to check your spam messages.</p>
                            </div>
                            <hr className='mb-3' style={{ color: "#a8a8a890" }} />
                            <p className='small'>Please retry if you didn't get the code. <span onClick={() => { setCodeSent(false); }} className='text-primary cursor-pointer'>Retry</span></p>
                        </>
                    }
                </div>
            </Modal>
        </>
    );
}

export default ForgotPassword;